import { ModuleWithProviders, NgModule } from '@angular/core';

import { PERMISSION } from './constants';
import { AtxPermissionGuard } from './guards';
import { AtxPermissionModel } from './model/atx-permission.model';
import { GuardsCheckStart, NavigationEnd, Router } from '@angular/router';

@NgModule({
    providers: [
        AtxPermissionModel,
        AtxPermissionGuard,
    ],
})

export class AtxPermissionModule {
    static forRoot(profile): ModuleWithProviders {
        return {
            ngModule: AtxPermissionModule,
            providers: [
                {
                    provide: PERMISSION,
                    multi: true,
                    useValue: profile,
                }
            ]
        }
    }

    constructor(
        private readonly router: Router,
        private readonly atxPermissionModel: AtxPermissionModel,
    ) {
        this.router.events
            .filter((events) => events instanceof NavigationEnd || events instanceof GuardsCheckStart)
            .subscribe((data: any) => atxPermissionModel.setAccessRequired(router.config, data.url));
    }
}
